export type * from "/tmp/build-252/node_modules/@eliadmin/core/src/components/auth/change-password-form.tsx";
export { changePasswordSchema } from "@eliadmin/core/src/components/auth/change-password-schema";
export { ChangePasswordForm } from './changePasswordForm-client';
